import React from 'react';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import './style.css';
import {config} from 'config';
import profilePic from '../../pages/photo_optimized.jpg';
import SiteLinks from '../SiteLinks';

class SiteHeader extends React.Component {
  render() {
    return (
      <header className="header">
        <div className="headerWrapper">
          <Link to={prefixLink('/')}>
            <img src={prefixLink(profilePic)} width="140" height="140" alt="Picture of me"/>
          </Link>
          <SiteLinks {...this.props} />
          <h1>{config.siteTitle}</h1>
          <p className="siteDescription">{config.siteDescr}</p>
        </div>
      </header>
    );
  }
}

SiteHeader.propTypes = {
  location: React.PropTypes.object,
};

export default SiteHeader;




// WEBPACK FOOTER //
// ../components/SiteHeader/index.jsx